/** @typedef {import('./typedefs.js').CompareItems} CompareItems */

/**
 * Parse compare items from JSON string
 *
 * @param {string | null} value
 * @returns {CompareItems}
 */
export default function parseCompareItems(value) {
  const { items = [] } = JSON.parse(value || '{}');
  return { items: items.map(({ prid, catalog, type }) => ({ prid, catalog, type })) };
}
